import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Media from "../../../../components/Media";
import ModalImage from "react-modal-image";
import {
  addWorkoutCategory,
  deleteWorkoutCategory,
  deleteWorkoutCategoryPermanently,
  getWorkoutCategories,
  restoreWorkoutCategory,
  updateWorkoutCategory,
  remove_session,
  sortWorkoutCategories,
} from "../../../../functions/general";
import { usePermissions } from "../../../../functions/usePermissions";

import { SortableContainer, SortableElement, SortableHandle, arrayMove } from "react-sortable-hoc";

function ListWorkoutCategories(props) {
  const { hasPermission } = usePermissions();

  const navigate = useNavigate();
  const [workoutCategories, setWorkoutCategories] = React.useState([]);
  const [modalTitle, setModalTitle] = React.useState("");
  const [modalButtonText, setModalButtonText] = React.useState("");
  const [title, setTitle] = React.useState("");
  const [image, setImage] = React.useState("");
  const [description, setDescription] = React.useState("");
  const [id, setId] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [tableDataLoading, setTableDataLoading] = React.useState(true);
  const [errors, setErrors] = React.useState("");
  useEffect(() => {
    props.setPageTitleAndSubTitle("Workout Categories", "Here is the list of Workout Categories !");
    fetchData();
  }, []);

  const fetchData = (type) => {
    getWorkoutCategories().then((res) => {
      if (res && res.status == 200) {
        setWorkoutCategories(res?.data);
        if (type === "add") {
          let sortedArray = [];
          res?.data?.map((category) => sortedArray.push(category?._id));
          sortWorkoutCategories(sortedArray).then((res) => {
            if (res && res.status == 200) {
              // fetchData();
            } else if (res && res.status == 401) {
              remove_session();
              props.getLoggedInUser();
              navigate("/login");
            } else {
              toast.error("Failed to sort the list.");
            }
            setTableDataLoading(false);
          });
        }
      } else if (res && res.status == 401) {
        remove_session();
        props.getLoggedInUser();
        navigate("/login");
      } else {
      }
      setTableDataLoading(false);
    });
  };

  const modalHandler = (category) => {
    if (category && category._id) {
      setModalTitle("Update Workout Category");
      setModalButtonText("Update");
      setTitle(category.title);
      setImage(category.image);
      setDescription(category.text);
      setId(category._id);
    } else {
      setModalTitle("Add New Workout Category");
      setModalButtonText("Add");
      setTitle("");
      setImage("");
      setDescription("");
      setId("");
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();
    if (loading) return false;
    if (validate()) {
      setLoading(true);
      const category = {
        title: title,
        image: image,
        text: description ? description:"",
      };
      if (id) {
        updateWorkoutCategory(id, category).then((res) => {
          if (res && res.status == 200) {
            fetchData();
            toast.success("Workout Category updated successfully.");
            document.getElementById("categoryModalCloseButton").click();
          } else if (res && res.status == 401) {
            remove_session();
            props.getLoggedInUser();
            navigate("/login");
          } else {
            toast.error("Failed to update Workout category.");
          }
          setLoading(false);
        });
      } else {
        addWorkoutCategory(category).then((res) => {
          if (res && res.status == 201) {
            fetchData();
            toast.success("Workout Category added successfully.");
            document.getElementById("categoryModalCloseButton").click();
          } else if (res && res.status == 401) {
            remove_session();
            props.getLoggedInUser();
            navigate("/login");
          } else {
            toast.error("Failed to add Workout category.");
          }
          setLoading(false);
        });
      }
    }
  };

  const validate = () => {
    let errors = {
      title: "",
      image: "",
      // description: "",
    };
    let isValid = true;
    if (!title) {
      isValid = false;
      errors.title = "Please enter title.";
    }
    if (!image) {
      isValid = false;
      errors.image = "Please select an image";
    }
    // if (!description) {
    //   isValid = false;
    //   errors.description = "Please enter description";
    // }
    setErrors(errors);
    return isValid;
  };

  const deleteHandler = (e, category) => {
    e.preventDefault();
    if (window.confirm("Are you sure you want to delete Workout category?") == true) {
      if (window.confirm("Are you sure you want to delete Workout category permanently?") == true) {
        deleteWorkoutCategoryPermanently(category._id).then((res) => {
          if (res && res.status == 200) {
            fetchData();
            toast.success("Workout Category deleted successfully.");
          } else if (res && res.status == 401) {
            remove_session();
            props.getLoggedInUser();
            navigate("/login");
          } else {
            toast.error("Failed to delete category.");
          }
        });
      }
    }
  };

  const deleteStatusHandler = (e, category) => {
    e.preventDefault();
    let confirmText = "Are you sure you want to in-active the Workout category?";
    if (category.isDeleted) {
      confirmText = "Are you sure you want to active the Workout category?";
    }
    if (window.confirm(confirmText) == true) {
      if (category.isDeleted) {
        restoreWorkoutCategory(category._id).then((res) => {
          if (res && res.status == 200) {
            fetchData();
            toast.success("Workout Category activated successfully.");
          } else if (res && res.status == 401) {
            remove_session();
            props.getLoggedInUser();
            navigate("/login");
          } else {
            toast.error("Failed to active category.");
          }
        });
      } else {
        deleteWorkoutCategory(category._id).then((res) => {
          if (res && res.status == 200) {
            fetchData();
            toast.success("Workout Category deactivated successfully.");
          } else if (res && res.status == 401) {
            remove_session();
            props.getLoggedInUser();
            navigate("/login");
          } else {
            toast.error("Failed to inactive category.");
          }
        });
      }
    }
  };

  const setImageHandler = (image) => {
    setImage(image);
  };

  const onSortEnd = ({ oldIndex, newIndex }) => {
    setTableDataLoading(true);
    const updatedWorkoutCategories = arrayMove(workoutCategories, oldIndex, newIndex);
    let sortedArray = [];
    updatedWorkoutCategories?.map((category) => sortedArray.push(category?._id));
    sortWorkoutCategories(sortedArray).then((res) => {
      if (res && res.status == 200) {
        setWorkoutCategories(updatedWorkoutCategories);
        // fetchData();
      } else if (res && res.status == 401) {
        remove_session();
        props.getLoggedInUser();
        navigate("/login");
      } else {
        toast.error("Failed to sort the list.");
      }
      setTableDataLoading(false);
    });
  };

  const DragHandle = SortableHandle(() => (
    <div
      style={{
        cursor: "move",
        width: "20px",
        height: "20px",
      }}
    >
      <svg
        aria-hidden="true"
        focusable="false"
        data-prefix="fas"
        data-icon="grip-vertical"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 320 512"
      >
        <path
          fill="#6e6e6e"
          d="M96 32H32C14.33 32 0 46.33 0 64v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zm0 160H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm0 160H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zM288 32h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zm0 160h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm0 160h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"
        ></path>
      </svg>
    </div>
  ));

  const SortableTableRow = SortableElement(({ category, serialNo }) => {
    return (
      <tr>
        <td>{serialNo + 1}</td>
        <td>
          <div className="maxWidth70px">
            <ModalImage small={process.env.REACT_APP_MEDIAPATH + category.image} large={process.env.REACT_APP_MEDIAPATH + category.image} />
          </div>
        </td>
        <td>{category.title}</td>
        {hasPermission("view-workout-subcategories") && (
          <td>
            <Link to={`/workout-subcategories`} state={{ category }} className="btn btn-dark btn-xs">
              {category?.count ? category?.count : 0}
            </Link>
          </td>
        )}
        {hasPermission("edit-workout-category") && (
          <td>
            <label className="switch">
              <input type="checkbox" checked={!category.isDeleted} onClick={(e) => deleteStatusHandler(e, category)} />
              <span className="slider round"></span>
            </label>
          </td>
        )}
        {(hasPermission("edit-workout-category") || hasPermission("delete-workout-category")) && (
          <td>
            <div className="d-flex">
              {hasPermission("edit-workout-category") && (
                <button
                  data-toggle="modal"
                  data-target="#add"
                  onClick={(e) => modalHandler(category)}
                  className="btn btn-primary shadow btn-sm sharp mr-1"
                >
                  <i className="fa fa-pencil"></i>
                </button>
              )}
              {hasPermission("delete-workout-category") && (
                <button onClick={(e) => deleteHandler(e, category)} className="btn btn-danger shadow btn-sm sharp">
                  <i className="fa fa-trash"></i>
                </button>
              )}
            </div>
          </td>
        )}
        {hasPermission("edit-workout-category") && (
          <td>
            <DragHandle />
          </td>
        )}
      </tr>
    );
  });

  const SortableTable = SortableContainer(({ workoutCategories }) => {
    return (
      <table id="roles-table" className="display dataTable" style={{ minWidth: "845px" }}>
        <thead>
          <tr>
            <th>No</th>
            <th>Image</th>
            <th>Name</th>
            {hasPermission("view-workout-subcategories") && <th>Subcategories</th>}
            {hasPermission("edit-workout-category") && <th>Status</th>}
            {(hasPermission("edit-workout-category") || hasPermission("delete-workout-category")) && <th>Actions</th>}
            {hasPermission("edit-workout-category") && <th>Sort Order</th>}
          </tr>
        </thead>
        <tbody>
          {tableDataLoading ? (
            <tr>
              <td colSpan="7" className="text-center pt-5">
                <div className="spinner-border text-black" role="status" aria-hidden="true"></div>
              </td>
            </tr>
          ) : (
            <>
              {workoutCategories ? (
                workoutCategories?.map((category, index) => {
                  return <SortableTableRow key={index} category={category} index={index} serialNo={index} />;
                })
              ) : (
                <tr>
                  <td colSpan="7" className="text-center pt-5">
                    No lecture category found!
                  </td>
                </tr>
              )}
            </>
          )}
        </tbody>
      </table>
    );
  });
  
  return (
    <>
      <div className="container-fluid">
        <div className="row mb-4">
          <div className="col-8">
            <ol class="breadcrumb bg-transparent mb-0" style={{ fontSize: "18px" }}>
              <li class="breadcrumb-item">
                <span onClick={() => navigate("/")}>
                  <i className="fas fa fa-home" style={{ fontSize: "28px", cursor: "pointer" }}></i>
                </span>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                Workout Categories
              </li>
            </ol>
          </div>
          <div className="col-4">
            {hasPermission("add-workout-category") && (
              <button className="btn btn-primary float-right" data-toggle="modal" data-target="#add" onClick={(e) => modalHandler()}>
                Add New
              </button>
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                <div className="table-responsive">
                  {tableDataLoading ? (
                    <div className="text-center py-5">
                      <div className="spinner-border text-black" role="status" aria-hidden="true"></div>
                    </div>
                  ) : (
                    <>
                      <SortableTable workoutCategories={workoutCategories} onSortEnd={onSortEnd} useDragHandle={true} />
                      {/* <table id="roles-table" className="display dataTable" style={{ minWidth: "845px" }}>
                        <thead>
                          <tr>
                            <th>No</th>
                            <th>Image</th>
                            <th>Name</th>
                            {hasPermission("view-workout-subcategories") && <th>Subcategories</th>}
                            {hasPermission("edit-workout-category") && <th>Status</th>}
                            {(hasPermission("edit-workout-category") || hasPermission("delete-workout-category")) && <th>Actions</th>}
                          </tr>
                        </thead>
                        <tbody>
                          {workoutCategories ? (
                            workoutCategories?.map((category, index) => {
                              return (
                                <tr>
                                  <td>{index + 1}</td>
                                  <td>
                                    <div className="maxWidth70px">
                                      <ModalImage
                                        small={process.env.REACT_APP_MEDIAPATH + category.image}
                                        large={process.env.REACT_APP_MEDIAPATH + category.image}
                                      />
                                    </div>
                                  </td>
                                  <td>{category.title}</td>
                                  {hasPermission("view-workout-subcategories") && (
                                    <td>
                                      <Link to={`/workout-subcategories`} state={{ category }} className="btn btn-dark btn-xs">
                                        {category?.count ? category?.count : 0}
                                      </Link>
                                    </td>
                                  )}
                                  {hasPermission("edit-workout-category") && (
                                    <td>
                                      <label className="switch">
                                        <input type="checkbox" checked={!category.isDeleted} onClick={(e) => deleteStatusHandler(e, category)} />
                                        <span className="slider round"></span>
                                      </label>
                                    </td>
                                  )}
                                  {(hasPermission("edit-workout-category") || hasPermission("delete-workout-category")) && (
                                    <td>
                                      <div className="d-flex">
                                        {hasPermission("edit-workout-category") && (
                                          <button
                                            data-toggle="modal"
                                            data-target="#add"
                                            onClick={(e) => modalHandler(category)}
                                            className="btn btn-primary shadow btn-sm sharp mr-1"
                                          >
                                            <i className="fa fa-pencil"></i>
                                          </button>
                                        )}
                                        {hasPermission("delete-workout-category") && (
                                          <button onClick={(e) => deleteHandler(e, category)} className="btn btn-danger shadow btn-sm sharp">
                                            <i className="fa fa-trash"></i>
                                          </button>
                                        )}
                                      </div>
                                    </td>
                                  )}
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td colSpan="6" className="text-center pt-5">
                                No Category found !
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table> */}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="modal fade" id="add">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header border-0 px-3 mb-3">
                <h5 className="modal-title">{modalTitle}</h5>
                <button type="button" className="close" data-dismiss="modal" id="categoryModalCloseButton">
                  <span>&times;</span>
                </button>
              </div>
              <form noValidate onSubmit={onSubmit}>
                <div className="form-group px-3">
                  <label>Title</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Workout Category Title"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                  />
                  {errors.title && !title && <div className="text-warning font-size-12 mt-2">{errors.title}</div>}
                </div>
                <div className="form-group px-3">
                  <label>Description</label>
                  <textarea
                    type="text"
                    className="form-control"
                    placeholder="Enter Description"
                    rows={4}
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                  />
                  {/* {errors.description && !description && <div className="text-warning font-size-12">{errors.description}</div>} */}
                </div>
                <div className="form-group px-3">
                  <label>Image</label>
                  <br />
                  {image && (
                    <>
                      <img src={process.env.REACT_APP_MEDIAPATH + image} className="img-fluid img-thumbnail" width="150" />
                      <br />
                    </>
                  )}
                  <button type="button" className="btn btn-primary mt-3" data-toggle="modal" data-target="#media">
                    Select Image
                  </button>
                  {errors.image && !image && <div className="text-warning font-size-12 mt-2">{errors.image}</div>}
                </div>
                <div className="modal-footer border-0">
                  <button type="submit" className="btn btn-primary">
                    {loading && <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>} {modalButtonText}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <Media setImageHandler={setImageHandler} />
      </div>
    </>
  );
}

export default ListWorkoutCategories;
